export default "__VITE_ASSET__DPEffqbt__"